import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/OrganizationNameButton.css";

import { House, SquaresFour } from "@phosphor-icons/react";
import { ProfileContext } from "../contexts/ProfileContext";

const OrganizationNameButton = () => {
  const { worker, organization } = useContext(ProfileContext);
  const iconProps = { size: 24, weight: "regular", color: "#106271" };
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/home");
  };

  return (
    <div className="org-name-button-display">
      <button className="org-name-button" onClick={handleHomeClick}>
        <SquaresFour {...iconProps} />
        <span className="org-name-button-label">
          {organization?.name ?? ""}
        </span>
      </button>
    </div>
  );
};

export default OrganizationNameButton;
